import script from "./reservationView.vue?vue&type=script&setup=true&lang=js"
export * from "./reservationView.vue?vue&type=script&setup=true&lang=js"

import "./reservationView.vue?vue&type=style&index=0&id=f78d2b06&lang=scss&scoped=true"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f78d2b06"]])

export default __exports__